import { ACCOUNT_XHR_BASE_PATH } from 'aa/vue/constants/aaRoutes';
import HttpService from 'aa/vue/services/HttpServiceBasic';

export default {
    namespaced: true,
    state: {
        billingInfo: null,
        checkedForStoredPaymentMethod: false,
        accountBalanceCoversPurchase: false, // set to true when user has enough gift balance in recurly to cover the cost
    },
    mutations: {
        setBillingInfo(state, billingInfo) {
            state.billingInfo = billingInfo;
            state.checkedForStoredPaymentMethod = true;
        },
        setCheckedForStoredPaymentMethod(state, checked) {
            state.checkedForStoredPaymentMethod = checked;
        },
        setAccountBalanceCoversPurchase(state, value) {
            state.accountBalanceCoversPurchase = value;
        },
    },
    actions: {
        async updateBillingInfo({ commit }) {
            try {
                const http = new HttpService();
                const response = await http.doGet(`${ACCOUNT_XHR_BASE_PATH}fetch-billing-data/`);

                if (response?.success) {
                    const billingInfo = response.result.billingInfo;
                    commit('setBillingInfo', billingInfo);
                } else {
                    console.error('Error in response of fetch billing data', response?.error);
                }
            } catch (err) {
                console.error('updateBillingInfo - caught exception', err);
            }
        },
    },
    getters: {
        getBillingInfo(state) {
            return state.billingInfo;
        },
        getAccountBalanceCoversPurchase(state) {
            return state.accountBalanceCoversPurchase;
        },
        alreadyCheckedForStoredPaymentMethod(state) {
            return state.checkedForStoredPaymentMethod;
        },
        hasValidStoredPaymentMethod(state) {
            if (
                state.accountBalanceCoversPurchase ||
                (state.billingInfo?.isTypeCard && !state.billingInfo?.isExpired) ||
                state.billingInfo?.isTypePaypal
            ) {
                return true;
            }

            return false;
        },
    },
};
